export class EventGA4{

  public event: string;
  public funnel_name: string = 'KOS';
  public sub_funnel_name: string;

  constructor(data){
    this.event = data.event;
    this.sub_funnel_name = data?.sub_funnel_name;
  }
}
